import React from 'react';
import { connect } from 'react-redux';

import { getIsHotelOnly } from 'src/store/view/selectors';
import { getPath } from '../../store/selectors/router';
import { getHeaderTitle } from '../../utils/viewUtils';

const baseCls = 'checkout-header';

const MobileHeaderTitle = ({ path, isHotelOnly }: PropsFromRedux) => {
  const title = getHeaderTitle(path, isHotelOnly);
  return title ? (
    <div className={baseCls}>
      <div className={`${baseCls}__title`}>{title}</div>
    </div>
  ) : null;
};

const mapPropsToState = (state) => ({
  path: getPath(state),
  isHotelOnly: getIsHotelOnly(state),
});

const connector = connect(mapPropsToState);
type PropsFromRedux = ReturnType<typeof mapPropsToState>;

export default connector(MobileHeaderTitle);
